const formatWeaponRange = range => {
  if (range) {
    switch (typeof range) {
      case 'object':
        return `${range.normal}/${range.max}`
      case 'number':
      case 'string':
      default:
        return range
    }
  }

  return ''
}

export default formatWeaponRange
